// Utils
import getTiptapContentLines from './getTiptapContentLines';

// Types
import { ImMap } from '../../../utils/immutableHelper';
import { TiptapContentNode } from '../../tiptapTypes';

/**
 * Retrieves the text content for a given Tiptap content node by traversing its nodes.
 */
const getTiptapNodeTextContent = (node: ImMap<TiptapContentNode> | TiptapContentNode): string =>
    getTiptapContentLines(node).join('\n');

export default getTiptapNodeTextContent;
